import { render, staticRenderFns } from "./EmailVerificationForm.vue?vue&type=template&id=30d4cc12"
import script from "./EmailVerificationForm.vue?vue&type=script&lang=js"
export * from "./EmailVerificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports